import { h, Component } from 'preact';
import cx from 'classnames';
import { toDecimal } from '../../../../core/decimal';
import { pricePerSqm } from '../../validators/post-property.validators';

interface NumberInputProps {
  disabled?: boolean;
  onValueChange: Function;
  fieldName: string;
  isInvalid?: boolean;

  extraClasses?: string; // use string over string[]

  min?: number;

  placeholder?: string;
  value?: any;
}

interface NumberInputState {
  value?: any;
  errMessage?: string;
  displayValue?: string;
  isEditing?: boolean;
}

// Decided to create a component for this
// vs creating functions to do the swapping of view vs value
// Much cleaner and code stable with this way - J.Jover
export class NumberInput extends Component<NumberInputProps, NumberInputState> {

  constructor(props) {
    super(props);

    if (props.value) {
      this.setState({
        value: this.formatToCommaNotation(props.value),
        errMessage: ""
      });
    }
  }

  formatToCommaNotation(value): string {
    let trimmed = Number.parseFloat(value).toFixed(2);
    let formatted = toDecimal(Number.parseFloat(trimmed));
    return formatted;
  }

  trimDecimals(value): number {
    let trimmed = Number.parseFloat(value).toFixed(2);
    let formatted = Number.parseFloat(trimmed);
    return formatted;
  }

  onChange = (e) => {
    const targetValue = e.target.value;
    this.setState({
      value: targetValue
    });
  }

  onFocus = (e) => {
    const val = this.state.value;
    this.setState({
      value: this.convertStringToFloat(val)
    })
  }

  onBlur = (e) => {
    const actual_value = this.state.value.toString();
    this.validateInput(actual_value);
  }

  validateInput(input: string) {

    const trimmed = input.replace(',', "")
    const string_arr = trimmed.split("");
    
    string_arr.forEach(char => {
      if (isNaN(parseInt(char))) {
        this.setState({
          errMessage: "Please enter a number",
          value: 0
        })
      } else {
        const final = this.formatToCommaNotation(trimmed)
        this.setState({
          errMessage: "",
          value: final
        })
        this.props.onValueChange(this.convertStringToFloat(final))
      }
    })
  }

  convertStringToFloat(str: string) {
    if (str) {
      const compressed = str.split(',').join("");
      return parseFloat(compressed)
    }
  }

  render(props: NumberInputProps, state: NumberInputState) {
    let errMsg = this.state.errMessage

    return(
      <div className="hi-currency-input">
        <input
          className={ cx('form-control',
          'hi-text-input',
          props.extraClasses, 
          {
            'invalid': props.isInvalid || errMsg !== "",
          })} 

          disabled={ props.disabled }
          type="text"
          min={props.min} 
          placeholder={props.placeholder}

          value={ this.state.value }
          onChange={ this.onChange }
          onBlur={ this.onBlur }
          onFocus={ this.onFocus }
          />
          { errMsg && <p className="text-danger"> { errMsg } </p> }
      </div>
    );
  }
}